import CandiceRichaud from "../../../../images/content/introduction/applia-secretariat/CandiceRichaud.webp";
import MartinOresic from "../../../../images/content/introduction/applia-secretariat/MartinOresic.webp";

export const AppliaSecretariatMembersTeam3 = [
	{
		name: "Candice Richaud",
		imageUrl: CandiceRichaud,
		background: "pages.introduction.appliaSecretariat.members.candiceRichaud.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.candiceRichaud.functionTitle",
	},
	{
		name: "Martin Orešić",
		imageUrl: MartinOresic,
		background: "pages.introduction.appliaSecretariat.members.martinOresic.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.martinOresic.functionTitle",
	},
];
